import React, { useState } from 'react';
import { Tooltip } from '../Tooltip';

import { translation } from '../JudgesHeadToHead/bottom-line';

import style from './side.module.scss';

const Side = ({ top, bottom, tooltip }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipCoords, setTooltipCoords] = useState();
  const [delayHandler, setDelayHandler] = useState();

  return (
    <div className={style.side}>
      <div>{top}</div>
      <div
        onMouseEnter={(e) => {
          const rect = e.target.getBoundingClientRect();
          setTooltipCoords({
            left: rect.x + rect.width / 2,
            top: rect.y + window.scrollY - 55
          });
          setDelayHandler(
            setTimeout(() => {
              setShowTooltip(true);
            }, 500)
          );
        }}
        onMouseLeave={() => {
          clearTimeout(delayHandler);
          setShowTooltip(false);
        }}
      >
        {showTooltip && (
          <Tooltip coords={tooltipCoords} updateTooltipCoords={setTooltipCoords}>
            <table
              style={{ width: 84, fontSize: 12, border: 0 }}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                {Object.values(translation).map(({ short, long }) => {
                  return (
                    <tr key={short}>
                      <td style={{ lineHeight: '16px', width: 16 }}>{short}</td>
                      <td style={{ lineHeight: '16px', width: 20, textAlign: 'center' }}>-</td>
                      <td style={{ lineHeight: '16px', width: 60 }}>{long}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Tooltip>
        )}
        {bottom}
      </div>
    </div>
  );
};

export { Side };
